/* eslint-disable camelcase */
import { gql } from '@apollo/client';
import claimVoucher from 'actions/user/claimVoucher';
import { setPrimaryOven } from 'actions/homeconnect';

// constants
import {
  HOME_CONNECT_PROMO_CLAIM_START,
  HOME_CONNECT_PROMO_CLAIM_ERROR,
  HOME_CONNECT_PROMO_CLAIM_ALLOWED,
  HOME_CONNECT_PROMO_CLAIM_DENIED,
} from 'constants/index';

const MUTATION = gql`
  mutation ClaimHomeConnectPremiumAccessPromo($brand: String) {
    ClaimHomeConnectPremiumAccessPromo(brand: $brand) {
      brand
      voucher_code
      eligible
      reason
      reason_code
      preferred_oven
    }
  }
`;

export default function claimHomeConnectPremiumAccessPromo(brand, params) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: HOME_CONNECT_PROMO_CLAIM_START,
      payload: { brand },
    });
    const { data, errors } = await client.mutate({
      mutation: MUTATION,
      variables: {
        brand,
      },
    });
    if (errors) {
      dispatch({
        type: HOME_CONNECT_PROMO_CLAIM_ERROR,
        payload: { brand, error: errors[0].graphQLErrors[0].message },
      });
    } else if (data && data.ClaimHomeConnectPremiumAccessPromo) {
      const { voucher_code, eligible, preferred_oven } = data.ClaimHomeConnectPremiumAccessPromo;
      if (eligible && voucher_code) {
        dispatch({
          type: HOME_CONNECT_PROMO_CLAIM_ALLOWED,
          payload: data.ClaimHomeConnectPremiumAccessPromo,
        });
        if (preferred_oven) {
          dispatch(setPrimaryOven({ haId: preferred_oven }));
        }
        dispatch(claimVoucher(voucher_code, params));
      } else {
        dispatch({
          type: HOME_CONNECT_PROMO_CLAIM_DENIED,
          payload: data.ClaimHomeConnectPremiumAccessPromo,
        });
      }
    } else {
      dispatch({
        type: HOME_CONNECT_PROMO_CLAIM_ERROR,
        payload: { brand, error: 'No data returned from API' },
      });
    }
  };
}
